
<DataPage
  ref="usersDataPage"
  :columns="columns"
  :filters="filters"
  :fetch-callback="fetchUsers"
  :model="UserModel"
  :title="__('entities.related-users')"
  has-row-actions
  :selectable="canSendRegistrationEmails"
  :row-selected="handleRowSelect"
>
  <template #pageHeader>
    <EntityShowHeader
      :entity="entity"
      :selected-rows="selectedRows"
      :can-send-registration-emails="canSendRegistrationEmails"
      @sendRegistrationEmailsClick="sendRegistrationEmails"
    />
  </template>

  <template #tableHeaderActions>
    <div class="d-flex align-items-center">
      <b-button
        v-can:entities.update
        v-can:users.create
        size="sm"
        variant="outline-primary"
        data-testid="create-user-btn"
        @click="openEntityUserCreateModal"
      >
        <Icon icon="plus-circle" size="14" class="mr-2" />
        {{ __('common.create-user') }}
      </b-button>
    </div>
  </template>

  <template #name="{ item }">
    <RouterLink
      v-if="authUser && item.id === authUser.id"
      :to="{ name: 'profile.show' }"
    >
      {{ item.name }}
    </RouterLink>
    <RouterLink
      v-else
      v-can:users.view
      :to="{ name: 'users.show', params: { userId: item.id } }"
    >
      {{ item.name }}
    </RouterLink>
  </template>

  <template #status="{ item }">
    <Badge :variant="item.statusData().badge">
      {{ item.statusData().label }}
    </Badge>
  </template>

  <template #role="{ item }">
    <span v-for="(role, index) in item.roles" :key="index" class="mr-1">
      <Badge variant="primary">
        {{ role.name }}
      </Badge>
    </span>
  </template>

  <template #entity="{ item }">
    <RouterLink
      :to="{
        name: 'entities.show',
        params: {
          entityId: item.defaultEntity?.id ?? item.defaultEntityId,
        },
      }"
    >
      {{ entityName(item) }}
    </RouterLink>
  </template>

  <template #actionButtons="{ item }">
    <ActionPopover v-if="authUser && item.id === authUser.id" :id="item.id">
      <b-button
        v-can:users.view
        class="dropdown-item"
        size="sm"
        :to="{ name: 'profile.show' }"
      >
        <Icon icon="eye" class="mr-2" size="14" />
        {{ __('buttons.show') }}
      </b-button>
    </ActionPopover>
    <ActionPopover
      v-else
      :id="item.id"
      v-can-any="['users.view', 'users.update']"
    >
      <b-button
        v-can:users.view
        class="dropdown-item"
        size="sm"
        :to="{ name: 'users.show', params: { userId: item.id } }"
      >
        <Icon icon="eye" class="mr-2" size="14" />
        {{ __('buttons.show') }}
      </b-button>

      <b-button
        v-can:users.update
        class="dropdown-item"
        size="sm"
        @click="handleEditUser(item)"
      >
        <Icon icon="edit" class="mr-2" size="14" />
        {{ __('buttons.edit') }}
      </b-button>

      <b-button
        v-can:users.email.registration
        class="dropdown-item"
        size="sm"
        @click="sendRegistrationEmail(item)"
      >
        <Icon icon="envelope-send" class="mr-2" size="14" />
        {{ __('users.send-registration-email') }}
      </b-button>
    </ActionPopover>
  </template>
</DataPage>
